"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var order_form_html_1 = __importDefault(require("./order-form.html"));
var order_form_controller_1 = __importDefault(require("./order-form.controller"));
function dsStudentOrderForm() {
    return {
        restrict: "E",
        scope: {
            submit: "=",
            order: "=",
        },
        template: order_form_html_1.default,
        link: function (scope, element, attrs) { },
        controller: order_form_controller_1.default,
        controllerAs: "vm",
        bindToController: true,
    };
}
exports.default = angular_1.default
    .module("student.directives.orderform", [])
    .controller("dsStudentOrderFormController", order_form_controller_1.default)
    .directive("dsStudentOrderForm", dsStudentOrderForm);
